export default "__VITE_ASSET__eEJ1R2gJ__"